import type { Feature } from '../content';

export function FeatureGrid({ features }: { features: Feature[] }) {
  return (
    <div className="feature-grid">
      {features.map((feature) => {
        const Icon = feature.icon;
        return (
          <article className="feature-card" key={feature.title}>
            <span className="icon-badge">
              <Icon size={22} />
            </span>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </article>
        );
      })}
    </div>
  );
}
